import { getRequest } from '../services/requestHandler';
import { PutterGripForSaveDto } from '../models';

export const getPutterGrips = async () => {
  const url = 'putter/getPutterGrips?activeOnly=true&useCache=false';
  const response = await getRequest<PutterGripForSaveDto>('GetPutterGrips', url);
  return response;
};
